var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { ContainerForm } from "../../components/ContainerForm";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { FormButton, FormButtonType } from "../../components/FormButton";
import { CardRedirectIpva } from "../../components/Habilitacao/CardRedirectIpva";
import { EmitirTodosBoletos } from "../../components/Habilitacao/EmitirTodosBoletos";
import { Loading } from "../../components/Loading";
import { Modal } from "../../components/Modal";
import { NaoEncontrado } from "../../components/NaoEncontrado";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { CardDebito } from "../../components/Veiculos/CardDebito";
import { InfoVeiculo } from "../../components/Veiculos/InfoVeiculo";
import { ViewPdf } from "../../components/ViewPdf";
import { useAuth } from "../../hooks/useAuth";
import { obterBoleto, obterDebitos } from "../../services/veiculos.service";
import { Colors } from "../../util/theme";
export var DebitosVeiculo = function () {
    var placa = useParams().placa;
    var userInfo = useAuth().userInfo;
    var _a = useState(), debitos = _a[0], setDebitos = _a[1];
    var _b = useState(), erro = _b[0], setErro = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), consultaVazia = _d[0], setConsultaVazia = _d[1];
    var _e = useState([]), selectedIds = _e[0], setSelectedIds = _e[1];
    var _f = useState(false), modalDebts = _f[0], setModalDebts = _f[1];
    var _g = useState(undefined), base64 = _g[0], setBase64 = _g[1];
    var handleChangeId = function (id) {
        if ((selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length) > 0) {
            setSelectedIds(function (prevSelectedIds) {
                if (prevSelectedIds.includes(id)) {
                    return prevSelectedIds.filter(function (selectedId) { return selectedId !== id; });
                }
                else {
                    return __spreadArray(__spreadArray([], prevSelectedIds, true), [id], false);
                }
            });
        }
        else {
            setSelectedIds([id]);
        }
    };
    var getSelectedDebtInfo = function (id) {
        if (debitos) {
            var selectedDebt = debitos.find(function (debito) { return debito.idDebito === id; });
            return selectedDebt;
        }
    };
    var fetchSelectedDebts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoading(true);
                    setErro(undefined);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    if (!(placa && selectedIds)) return [3 /*break*/, 3];
                    payload = {
                        cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        placa: placa,
                        listaIdDebito: selectedIds.toString(),
                    };
                    return [4 /*yield*/, obterBoleto(payload)];
                case 2:
                    response = _d.sent();
                    setBase64(response.pdf);
                    _d.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_1 = _d.sent();
                    setErro((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao gerar boleto");
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    setModalDebts(false);
                    setSelectedIds([]);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchDebitos = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_2;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, 4, 5]);
                        if (!placa) return [3 /*break*/, 2];
                        payload = {
                            placa: placa,
                        };
                        return [4 /*yield*/, obterDebitos(payload)];
                    case 1:
                        response = _d.sent();
                        if (response[0].descricaoServico) {
                            setDebitos(response);
                        }
                        else {
                            setConsultaVazia(true);
                        }
                        _d.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        error_2 = _d.sent();
                        if (error_2.response &&
                            ((_a = error_2.response.data) === null || _a === void 0 ? void 0 : _a.MensagemRetorno) ===
                                "Não há débitos para o veículo informado.") {
                            setConsultaVazia(true);
                        }
                        else {
                            setErro((_c = (_b = error_2.response.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao buscar débitos do veículo selecionado");
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchDebitos();
    }, [placa]);
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "D\u00E9bitos do Ve\u00EDculo", goBackTo: "/veiculos/consulta-licenciamentos" }), _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsx(InfoVeiculo, {}), _jsxs(Stack, __assign({ mb: "2rem" }, { children: [_jsx(ContainerForm, __assign({ title: "" }, { children: _jsx(CardRedirectIpva, {}) })), debitos && (debitos === null || debitos === void 0 ? void 0 : debitos.length) > 1 && placa && (_jsx(ContainerForm, __assign({ title: "" }, { children: _jsx(EmitirTodosBoletos, { debts: debitos, plate: placa }) })))] })), !consultaVazia ? (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ variant: "h5", fontSize: "1.375rem", fontWeight: "500", mb: "1rem" }, { children: "D\u00E9bitos em Aberto" })), (selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.length) > 0 && (_jsx(Button, __assign({ variant: "contained", onClick: function () { return setModalDebts(true); } }, { children: "Emitir Selecionados" })))] })), _jsx(Divider, { sx: { my: "1rem" } }), debitos === null || debitos === void 0 ? void 0 : debitos.map(function (debito) { return (_jsx(CardDebito, { debito: debito, onChangeCheckbox: function (id) { return handleChangeId(id); } }, debito.idDebito)); })] })) : (_jsx(Box, __assign({ mt: "10rem" }, { children: _jsx(ContainerLayout, { children: _jsx(NaoEncontrado, { subtitulo: "O sistema n\u00E3o localizou nenhum d\u00E9bito para o condutor selecionado." }) }) })))] }) })), _jsx(Modal, __assign({ open: modalDebts, onClose: function () { return setModalDebts(false); }, icon: _jsx(Stack, __assign({ bgcolor: Colors.AZUL_GOV, borderRadius: "50%", p: "0.5rem" }, { children: _jsx(ChecklistOutlinedIcon, { sx: { color: "white" } }) })), title: "Emitir todos os d\u00E9bitos?", directionButtons: "row-reverse", buttons: [
                    _jsx(FormButton, { onClick: fetchSelectedDebts, title: "Confirmar", type: FormButtonType.PRIMARY, isLoading: loading, isDisabled: loading }, 0),
                    _jsx(FormButton, { onClick: function () { return setModalDebts(false); }, title: "Cancelar", type: FormButtonType.SECONDARY, isDisabled: loading }, 1),
                ] }, { children: selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.map(function (id) {
                    var _a, _b, _c;
                    return (_jsxs(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: ["- ", (_a = getSelectedDebtInfo(id)) === null || _a === void 0 ? void 0 : _a.descricaoClasse, " ", (_b = getSelectedDebtInfo(id)) === null || _b === void 0 ? void 0 : _b.exercicio, " - R$", " ", parseFloat(getSelectedDebtInfo(id).valorVencimento).toFixed(2)] }), (_c = getSelectedDebtInfo(id)) === null || _c === void 0 ? void 0 : _c.idDebito));
                }) })), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: "D\u00E9bitos do Ve\u00EDculo" })), erro && (_jsx(SnackbarFeedback, { isOpen: !!erro, message: erro, type: "error" }))] }));
};
